import { isSafari  } from '@core/utils/userAgent/UAUtils';

export function printPage() {
    return new Promise((resolve) => {
        window.print();
        if (isSafari()) {
            // print in Safari is a non blocking function
            const callback = () => {
                window.removeEventListener('focus', callback);
                resolve();
            };
            window.addEventListener('focus', resolve);
        } else {
            resolve();
        }
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/utils/browserAPI.ts